import { DateTimeStr } from '../../types';
import { BaseAPIClient } from '../base_client';

export const TranscriptionAPI = {
  fetchSearch(
    this: BaseAPIClient,
    station: string,
    from: DateTimeStr,
    to: DateTimeStr,
    query: string,
  ) {
    return this.get(
      `/stations/${station}/transcription/simple-search?query=${query}&from=${from}&to=${to}&groupByLength=60`,
    );
  },
};
